export default __webpack_public_path__ + "static/media/events-cat.e06a8475.webp";